import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_100: DocMigration = {
  maxSchemaVersion: "0.0.100",
  description: "Remove references to deleted facades",
  apply(json: any) {
    if (json.roomLayouts) {
      const facades = json.facades || {};
      const roomLayouts = json.roomLayouts;
      if (roomLayouts) {
        for (const roomLayoutId in roomLayouts) {
          const roomLayout = roomLayouts[roomLayoutId];
          if (roomLayout.edgeLabels) {
            roomLayout.edgeLabels = roomLayout.edgeLabels.filter((x) => !!facades[x.name]);
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_100;
